import { useState } from "react";
import dynamic from "next/dynamic";
import Cityoptions from "./Options";
import { useRouter } from "next/router";
import { Response } from "../../../types/Response.interface";
import useDebounce from "../../../hooks/useDebounce";
const CityBar = dynamic(() => import("../../../components/CityBar"), {
  suspense: true,
});

const CitySearch = () => {
  const [options, setOptions] = useState(Cityoptions);
  const router = useRouter();
  const _onSearch = async (value: string) => {
    const res: Response = await (await import("./city.api")).default(value);

    if (res.ok) {
      setOptions(res.data.data);
    }
  };

  const onSearch = useDebounce(_onSearch, 200);

  return (
    <div className="w-full p-0">
      <CityBar
        onSearch={onSearch}
        mode="screen"
        options={options}
        onSelect={(city) => router.push(`/newconstruction/city/${city}`)}
      />
    </div>
  );
};

export default CitySearch;
